import React, { useMemo } from "react";

type Banner = { URL?: string; Title?: string };

export const CachedBannerImage = React.memo(function CachedBannerImage({
  banner,
  index,
  className,
  fallbackSrc,
}: {
  banner?: Banner;
  index: number;
  className?: string;
  fallbackSrc?: string;
}) {
  const url = banner?.URL || fallbackSrc;

  const alt = useMemo(
    () => banner?.Title || `Banner ${index + 1}`,
    [banner?.Title, index]
  );

  return (
    <img
      src={url}
      alt={alt}
      className={className}
      loading="eager"
      decoding="sync"
      fetchpriority="high"
      width="1920"
      height="400"
      onError={(e) => {
        if (fallbackSrc && e.currentTarget.src !== fallbackSrc) {
          e.currentTarget.src = fallbackSrc;
        }
      }}
    />
  );
});
